import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { TrpcProvider } from "./TrpcProvider";
import { initAnalytics } from "./analytics";
import { Router } from "./router";
import { initSentry } from "./sentry";
import "./index.css";

initSentry();
initAnalytics();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
document.documentElement.lang = window.location.pathname.startsWith("/hi")
  ? "hi"
  : "en-SG";

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <TrpcProvider>
        <Router />
      </TrpcProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
